import React from 'react';
import styled from 'styled-components';
import Box from './Box';
import Flex from './Flex';
import Text from './Text';

const Checkmark = styled.span`
  position: absolute;
  left: 8px;
  top: 3px;
  width: 8px;
  border-radius: 2px;
  height: 15px;
  border: solid white;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
`;

export default class Checkbox extends React.Component {
  render() {
    const { checked, label, onChange, textStyle = 'body', ...rest } = this.props;

    return (
      <Flex
        as="label"
        alignItems="center"
        css="cursor: pointer;"
        py={2}
        onClick={e => e.stopPropagation()}
        {...rest}
      >
        <Box
          bg={checked ? 'primary' : 'white'}
          border={checked ? 'primary' : 'divider'}
          borderRadius="4px"
          height="24px"
          width="24px"
          mr={2}
        >
          <input
            style={{ width: 0, height: 0, visibility: 'hidden' }}
            type="checkbox"
            checked={checked}
            onChange={onChange}
          />
          {checked ? <Checkmark /> : null}
        </Box>
        {typeof label === 'string' ? <Text textStyle={textStyle}>{label}</Text> : label}
      </Flex>
    );
  }
}
